import { Text } from "@mantine/core";

type NavSectionErrorItemProps = {
	label: string;
};

function NavSectionErrorItem(props: NavSectionErrorItemProps) {
	return (
		<div className="flex items-center justify-center h-10 w-full">
			<Text truncate="end" fz="lg">
				{props.label}
			</Text>
		</div>
	);
}

export default NavSectionErrorItem;
